import React, { FC } from 'react';
import styles from './PopUpTextLink.module.scss';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

// Import static assets
import FulfillmentPopup from '@/libs/fulfillmentPopup/fulfillmentPopup';
import { useResourceContext } from '@/context/resourceContext';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
import { useEnvContext } from '@/context/envContext';
const PopUpTextLink: FC = () => {
  const t = useTranslations('Fulfillment');
  const {
    docUrl
  } = useResourceContext();
  const {
    cdnEnv
  } = useEnvContext();

  // If cdnEnv is undefined use prods hardcoded url path, will happen on notFoumd page
  const infoIcon = cdnEnv ? `${cdnEnv}/rms/images/icons/info-icon.svg` : 'https://media.techtarget.com/rms/images/icons/info-icon.svg';
  return <p className={styles['visit-the-asset']} data-sentry-component="PopUpTextLink" data-sentry-source-file="PopUpTextLink.tsx">
   <Image className={styles['info-icon']} priority={true} src={infoIcon} alt={'info-icon'} aria-hidden={true} width={15} height={15} data-sentry-element="Image" data-sentry-source-file="PopUpTextLink.tsx" />
   <i> {t('NoNewWindow')}</i>
   <button onClick={() => {
      FulfillmentPopup(docUrl);
      pushGTMClickTags({
        click_element: 'Button',
        click_closest_class: 'NONE',
        click_section_ID: 'NONE',
        link_classes: 'text-links',
        link_id: 'NONE',
        link_text: 'View the asset',
        link_url: 'NONE',
        click_category: 'NONE',
        click_destination: 'popup',
        click_closest_href: 'NONE'
      });
    }} className={'text-links'}>
    <span className={styles['click-here-links']}>{t('ClickHere')}</span>
   </button>
   <i>{t('ViewTheAsset')}</i>
  </p>;
};
export default PopUpTextLink;